import styled from 'styled-components'
import { colors } from '../../../../styles/constants'

export const CardWrapper = styled.div`
  margin-bottom: 16px;
`

export const Container = styled.div`
  margin: 0 16px 24px 16px;
  span {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Title = styled.h1`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: ${colors.gray.darker};
  margin-bottom: -8px;
  letter-spacing: .96px;
`

export const Subtitle = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 8px;
  color: ${colors.gray.dark};
`
